import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LocaleContext } from "../../../../routing/LangRouter";

//import utils
import { navigateToLoginPage } from "../../../../utils/utility";

//import constants
import BASE_URL from "../../../../constants/baseUrls";
import { IS_MOBILE } from "../../../../constants/breakpoints";

//import general components
import BaseTitle from "../../../common/base-title/base-title";
import Loading from "../../../common/loading/loading";
import EmptyOrErrorState from "../../../common/empty-or-error-state/empty-or-error-state";

//import view components
import MyTourItem from "./my-tour-item";

//import images and icons
import { InfoCircle } from "iconsax-react";

function MyTours() {
    //general variables
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");

    //handle unauthorized error (401 status)
    const handleUnauthorizedError = () => {
        localStorage.clear();
        navigateToLoginPage(navigate, locale, location);
    };

    const [myTourList, setMyTourList] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const getMyTours = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(`${BASE_URL}/api/v2/account/user/tour/history/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setMyTourList(response?.data?.data);
        } catch (error) {
            if (error.response.status === 401) {
                handleUnauthorizedError();
            } else {
                toast.error(t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            }
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getMyTours();
    }, []);

    return (
        <Grid container item xs={12} rowGap={2} columnGap={4} justifyContent="center" mt={{ xs: 5, md: 0 }} mb={5}>
            {!IS_MOBILE && <BaseTitle title={`${t("myTours")}`} dividerColor="1px solid var(--medium-gray-color)" />}
            {isLoading ? (
                <Loading />
            ) : myTourList?.results?.length ? (
                myTourList?.results.map(tourItem => {
                    return (
                        <Grid key={tourItem.id} container item xs={12}>
                            <MyTourItem information={tourItem} tourItem={tourItem.tour} />
                        </Grid>
                    );
                })
            ) : (
                <EmptyOrErrorState
                    title={t("Messages.No Tours Available")}
                    icon={<InfoCircle size="32" color="var(--secondary-color)" variant="Bold" />}
                />
            )}
        </Grid>
    );
}

export default MyTours;
